import * as React from 'react';
import { ContentfulFrame, ContentfulHeroFrame } from '../../interfaces';
import { FramePageDisplay } from '../frame-page-display/frame-page-display';

interface FramePageControllerProperties {
  isHomePage: boolean;
  frames: Array<ContentfulFrame | ContentfulHeroFrame>;
  theme?: string;
  useDarkTheme: boolean;
}

export const FramePageController = (props: FramePageControllerProperties) => {
  return (
    <FramePageDisplay
      isHomePage={props.isHomePage}
      frames={props.frames}
      theme={props.theme}
      isDarkTheme={props.useDarkTheme}
    />
  );
};
